module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/logo-da6346c6b3a657e116ac49119b3e974d.svg";